module.exports = __webpack_public_path__ + "static/xero-goldpartner-logo-e0043f7e8a928f447cb42971357a8836.png";